import { useAuthDispatch } from "../state/auth";
import { toSingleValue } from "../utils/stringUtil";
import type { Location } from "@solidjs/router";
import { useMatch, useNavigate, useSearchParams } from "@solidjs/router";
import CustomerId from "../state/CustomerId";
import { isNil } from "lodash-es";

export enum Impersonation {
  USER = "impersonate-user",
  CUSTOMER = "impersonate-customer",
}

const unsetQueryParam = (queryParam: string) => {
  const [, setSearchParams] = useSearchParams();
  setSearchParams({ [queryParam]: undefined });
};

export const handleImpersonation = (location: Location) => {
  const { impersonateCustomer, impersonateUser } = useAuthDispatch();
  const navigate = useNavigate();
  const match = useMatch(() => "/customers/:customerId/*");
  const { pathname, query } = location;

  if (query[Impersonation.USER] !== undefined) {
    impersonateUser(toSingleValue(query[Impersonation.USER]));
    unsetQueryParam(Impersonation.USER);
  }

  if (query[Impersonation.CUSTOMER] !== undefined) {
    const customerIdToImpersonate = toSingleValue(query[Impersonation.CUSTOMER]);
    const customerIdFromUrl = match()?.params?.customerId;

    impersonateCustomer(CustomerId.from(customerIdToImpersonate));
    unsetQueryParam(Impersonation.CUSTOMER);

    // Navigate to the impersonated customer
    if (isNil(customerIdFromUrl)) {
      navigate(`/customers/${customerIdToImpersonate}`);
    } else if (customerIdToImpersonate !== customerIdFromUrl) {
      navigate(pathname.replace(`/customers/${customerIdFromUrl}`, `/customers/${customerIdToImpersonate}`));
    }
  }
};
